import { INumber } from '../../../model';
import { ITableColumnMultiHeader } from './column';

export interface IMultiHeader<T> {
  // 实现表头多行, 这里只满足简单的二级表头归类，严格来说这不是一个多级表头的选项，因为实现成本比较大。
  // 单纯从表格组件角度来看，是可以实现多级表头。
  // 如后续需要实现此参数会向下兼容。
  readonly multiRowsHeader?: ReadonlyArray<ITableColumnMultiHeader<T>>;

  // 是否开启多级表头支持折叠展开，默认不开启
  readonly enabledMultiColumnCollapse?: boolean;

  // 展开和折叠的索引
  readonly multiColumnCollapseIndex?: INumber<ReadonlyArray<number>>;
}

export enum CollapseColumnRenderType {
  Header = 'header',
  Body = 'body',
}
